export default {"src":"/_next/static/media/yard-maintenance.0d708cc7.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};